<template>
  <input
    :id="clientBitDumb ? 'phone-plain' : 'phone-masked'"
    :placeholder="placeholder"
    :value="phone"
    @input="onInput"
    autocomplete="tel"
    type="text"
  />
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "PhoneInput",
  props: {
    placeholderPhone: String,
    county: {
      type: String,
      default: "Российская Федерация",
      required: false
    }
  },
  data() {
    return {
      phone: "",
      clientBitDumb: false,
      placeholder: this.placeholderPhone || "999 999 99 99"
    };
  },
  methods: {
    russiaChangeNumber(digits: string) {
      if (
        digits.length > 10 &&
        (digits.startsWith("7") || digits.startsWith("8"))
      ) {
        digits = digits.slice(1);
      }

      return digits;
    },
    kzChangeNumber(digits: string) {
      if (
        digits.length > 10 &&
        (digits.startsWith("7") || digits.startsWith("8"))
      ) {
        digits = digits.slice(1);
      }

      return digits;
    },
    onInput(e: Event) {
      const target = e.target as HTMLInputElement;
      let value = target.value;
      const raw = value.replace(/\D/g, "");

      if (this.clientBitDumb) {
        this.phone = raw;
        return;
      }

      let digits = raw;

      if (
        this.county == "Россия (+7)" ||
        this.county == "Российская Федерация"
      ) {
        digits = this.russiaChangeNumber(digits);
      } else if (
        this.county == "Казахстан" ||
        this.county == "Казахстан (+7)"
      ) {
        digits = this.kzChangeNumber(digits);
      }

      const maskedDigits = digits.slice(0, 10);
      const extraDigits = digits.slice(10);

      const maskedPhone = maskedDigits.replace(
        /^(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/,
        (_: string, p1: string, p2: string, p3: string, p4: string) => {
          let result = "";
          if (p1) result += p1;
          if (p2) result += " " + p2;
          if (p3) result += "-" + p3;
          if (p4) result += "-" + p4;
          return result;
        }
      );

      this.phone = maskedPhone + extraDigits;
    }
  },
  watch: {
    phone(val) {
      this.$emit("update:modelValue", val);
    }
  }
});
</script>
